// extracted by mini-css-extract-plugin
export var addButton = "_dr-4";
export var contentBlockImage = "_dr-i";
export var contentBlockWidgetPreview = "_dr-g";
export var fulfillmentCutoffWidgetPreview = "_dr-9";
export var imageBackdrop = "_dr-6";
export var imageIcon = "_dr-8";
export var lowProfileImageContainer = "_dr-b";
export var lowProfileImageIcon = "_dr-f";
export var lowProfileImageIconContainer = "_dr-e";
export var lowProfileImagePlaceholder = "_dr-d";
export var lowProfileProductImage = "_dr-c";
export var lowProfileProductUpsellWidgetPreview = "_dr-a";
export var productCard = "_dr-5";
export var productImage = "_dr-7";
export var productReviewsWidgetPreview = "_dr-h";
export var progressBar = "_dr-1";
export var progressBarFill = "_dr-2";
export var progressBarTrack = "_dr-3";
export var shippingOptionWidgetPreview = "_dr-j";
export var shippingUpsellProgressBar = "_dr-k";
export var thresholdUpsellWidgetPreview = "_dr-0";